// 'use client'

// import { useState, useRef, useEffect } from 'react'
// import { Download, ChevronDown, FileText, Calendar } from 'lucide-react'
// import jsPDF from 'jspdf'
// import autoTable from 'jspdf-autotable'

// interface ReportDropdownProps {
//   className?: string;
// }

// interface DateRange {
//   label: string;
//   startDate: Date;
//   endDate: Date;
// }

// interface ReportData {
//   date: string;
//   verificationRates: {
//     arrondissement: string;
//     registered: number;
//     verified: number;
//     rate: number;
//   }[];
//   ageSegmentation: {
//     ageRange: string;
//     count: number;
//     percentage: number;
//   }[];
// }

// const ReportsDropdown = ({ className }: ReportDropdownProps) => {
//   const [isOpen, setIsOpen] = useState(false)
//   const [dateRange, setDateRange] = useState<DateRange>({
//     label: 'Last Week',
//     startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
//     endDate: new Date()
//   })
//   const [showDateOptions, setShowDateOptions] = useState(false)
//   const dropdownRef = useRef<HTMLDivElement>(null)

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
//         setIsOpen(false)
//         setShowDateOptions(false)
//       }
//     }

//     document.addEventListener('mousedown', handleClickOutside)
//     return () => document.removeEventListener('mousedown', handleClickOutside)
//   }, [])

//   // Date range options
//   const dateOptions = [
//     { label: 'Last Week', days: 7 },
//     { label: 'Last Month', days: 30 },
//     { label: 'Last 3 Months', days: 90 },
//     { label: 'Custom Range', days: 0 }
//   ]

//   // Sample data for reports (replace with your actual data)
//   const getReportData = (): ReportData => {
//     const formatDate = (date: Date) => {
//       return date.toLocaleDateString('fr-FR', {
//         day: 'numeric',
//         month: 'long',
//         year: 'numeric'
//       })
//     }

//     return {
//       date: formatDate(new Date()),
//       verificationRates: [
//         { arrondissement: 'Yaoundé I', registered: 212, verified: 160, rate: 75 },
//         { arrondissement: 'Yaoundé II', registered: 185, verified: 114, rate: 61 },
//         { arrondissement: 'Yaoundé III', registered: 200, verified: 106, rate: 53 },
//         { arrondissement: 'Yaoundé IV', registered: 178, verified: 144, rate: 81 },
//         { arrondissement: 'Yaoundé V', registered: 164, verified: 90, rate: 55 },
//         { arrondissement: 'Yaoundé VI', registered: 181, verified: 98, rate: 54 },
//         { arrondissement: 'Yaoundé VII', registered: 128, verified: 48, rate: 38 }
//       ],
//       ageSegmentation: [
//         { ageRange: '0 – 5 ans', count: 4, percentage: 0.3 },
//         { ageRange: '6 – 10 ans', count: 42, percentage: 3.4 },
//         { ageRange: '11 – 15 ans', count: 317, percentage: 25.4 },
//         { ageRange: 'Plus de 15 ans', count: 887, percentage: 70.9 },
//         { ageRange: 'Total', count: 1250, percentage: 100 }
//       ]
//     }
//   }

//   const handleDateRangeSelect = (option: typeof dateOptions[0]) => {
//     if (option.label === 'Custom Range') {
//       // For custom range, you could open a date picker here
//       // For now, we'll use last month
//       const endDate = new Date()
//       const startDate = new Date()
//       startDate.setDate(startDate.getDate() - 30)
      
//       setDateRange({
//         label: 'Custom Range (Last 30 days)',
//         startDate,
//         endDate
//       })
//     } else {
//       const endDate = new Date()
//       const startDate = new Date()
//       startDate.setDate(startDate.getDate() - option.days)
      
//       setDateRange({
//         label: option.label,
//         startDate,
//         endDate
//       })
//     }
//     setShowDateOptions(false)
//   }

//     const generateVerificationReport = () => {
//     const doc = new jsPDF()
//     const data = getReportData()
//     const pageWidth = doc.internal.pageSize.getWidth()
    
//     // Title split into two lines
//     doc.setFontSize(16)
//     doc.setFont('helvetica', 'bold')
    
//     // First line of title
//     const titleLine1 = 'RAPPORT D\'ANALYSE DES TAUX DE TAXIS'
//     const titleLine2 = 'VÉRIFIÉS PAR ARRONDISSEMENT'
    
//     doc.text(titleLine1, pageWidth / 2, 20, { align: 'center' })
//     doc.text(titleLine2, pageWidth / 2, 28, { align: 'center' })
    
//     // Subtitle
//     doc.setFontSize(12)
//     doc.setFont('helvetica', 'normal')
//     const subtitle = 'Plateforme digitale d\'enregistrement et de vérification des taxis'
//     doc.text(subtitle, pageWidth / 2, 40, { align: 'center' })
    
//     // Date
//     doc.text(`Date d'édition : ${data.date}`, pageWidth / 2, 48, { align: 'center' })
    
//     // Table title
//     doc.setFontSize(14)
//     doc.setFont('helvetica', 'bold')
//     doc.text('Tableau comparatif par arrondissement', 20, 68)
    
//     // Table
//     autoTable(doc, {
//         startY: 78,
//         head: [['Arrondissement', 'Taxis enregistrés', 'Taxis vérifiés', 'Taux (%)']],
//         body: data.verificationRates.map(row => [
//         row.arrondissement,
//         row.registered.toString(),
//         row.verified.toString(),
//         `${row.rate} %`
//         ]),
//         theme: 'grid',
//         headStyles: {
//         fillColor: [66, 135, 245], // Primary color
//         textColor: 255,
//         fontStyle: 'bold'
//         },
//         styles: {
//         fontSize: 10,
//         cellPadding: 5
//         },
//         margin: { left: 20, right: 20 }
//     })
    
//     // Footer
//     const finalY = (doc as any).lastAutoTable.finalY || 100
//     doc.setFontSize(10)
//     doc.setFont('helvetica', 'normal')
//     doc.text(`Période : ${dateRange.label}`, 20, finalY + 20)
//     doc.text(`Généré le : ${new Date().toLocaleDateString('fr-FR')}`, pageWidth - 20, finalY + 20, { align: 'right' })
    
//     // Save PDF
//     doc.save(`rapport-verification-${dateRange.label.toLowerCase().replace(' ', '-')}-${new Date().toISOString().split('T')[0]}.pdf`)
//     }

//   const generateAgeSegmentationReport = () => {
//     const doc = new jsPDF()
//     const data = getReportData()
//     const pageWidth = doc.internal.pageSize.getWidth()
    
//     // Title
//     doc.setFontSize(16)
//     doc.setFont('helvetica', 'bold')
//     doc.text('RAPPORT DE SEGMENTATION DU PARC DE TAXIS PAR TRANCHES D\'ÂGE', pageWidth / 2, 20, { align: 'center' })
    
//     // Subtitle
//     doc.setFontSize(12)
//     doc.setFont('helvetica', 'normal')
//     doc.text('Plateforme digitale d\'enregistrement et de vérification des taxis', pageWidth / 2, 30, { align: 'center' })
    
//     // Date
//     doc.text(`Date d'édition : ${data.date}`, pageWidth / 2, 40, { align: 'center' })
    
//     // Table title
//     doc.setFontSize(14)
//     doc.setFont('helvetica', 'bold')
//     doc.text('Tableau comparatif par tranche d\'âge du véhicule', 20, 60)
    
//     // Table
//     autoTable(doc, {
//       startY: 70,
//       head: [['Tranche d\'âge du véhicule', 'Nombre de taxis', 'Part du parc (%)']],
//       body: data.ageSegmentation.map(row => [
//         row.ageRange,
//         row.count.toLocaleString('fr-FR'),
//         `${row.percentage.toFixed(1).replace('.', ',')} %`
//       ]),
//       theme: 'grid',
//       headStyles: {
//         fillColor: [66, 135, 245], // Primary color
//         textColor: 255,
//         fontStyle: 'bold'
//       },
//       styles: {
//         fontSize: 10,
//         cellPadding: 5
//       },
//       margin: { left: 20, right: 20 }
//     })
    
//     // Footer
//     const finalY = (doc as any).lastAutoTable.finalY || 100
//     doc.setFontSize(10)
//     doc.setFont('helvetica', 'normal')
//     doc.text(`Période : ${dateRange.label}`, 20, finalY + 20)
//     doc.text(`Généré le : ${new Date().toLocaleDateString('fr-FR')}`, pageWidth - 20, finalY + 20, { align: 'right' })
    
//     // Save PDF
//     doc.save(`rapport-segmentation-âge-${dateRange.label.toLowerCase().replace(' ', '-')}-${new Date().toISOString().split('T')[0]}.pdf`)
//   }

//   return (
//     <div className={`relative ${className}`} ref={dropdownRef}>
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors text-sm font-semibold"
//       >
//         <Download size={18} />
//         <span>Download Reports</span>
//         <ChevronDown size={16} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
//       </button>

//       {isOpen && (
//         <div className="absolute top-full right-0 mt-2 w-64 bg-white rounded-xl shadow-lg border border-slate-200 z-50 overflow-hidden">
//           {/* Date Range Selector */}
//           <div className="p-4 border-b border-slate-200">
//             <button
//               onClick={() => setShowDateOptions(!showDateOptions)}
//               className="flex items-center justify-between w-full p-3 bg-slate-50 hover:bg-slate-100 rounded-lg text-sm font-medium text-slate-700 transition-colors"
//             >
//               <div className="flex items-center gap-2">
//                 <Calendar size={16} className="text-slate-400" />
//                 <span>{dateRange.label}</span>
//               </div>
//               <ChevronDown size={16} className={`transition-transform ${showDateOptions ? 'rotate-180' : ''}`} />
//             </button>

//             {showDateOptions && (
//               <div className="mt-2 bg-white border border-slate-200 rounded-lg shadow-sm">
//                 {dateOptions.map((option) => (
//                   <button
//                     key={option.label}
//                     onClick={() => handleDateRangeSelect(option)}
//                     className="w-full px-4 py-2 text-left text-sm text-slate-700 hover:bg-slate-50 first:rounded-t-lg last:rounded-b-lg transition-colors"
//                   >
//                     {option.label}
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* Report Options */}
//           <div className="p-2">
//             <button
//               onClick={() => {
//                 generateVerificationReport()
//                 setIsOpen(false)
//               }}
//               className="flex items-center gap-3 w-full p-3 rounded-lg hover:bg-slate-50 text-slate-700 hover:text-slate-900 transition-colors text-sm font-medium"
//             >
//               <div className="p-2 bg-blue-50 text-primary rounded-lg">
//                 <FileText size={18} />
//               </div>
//               <div className="text-left">
//                 <div className="font-semibold">Verification Rates Report</div>
//                 <div className="text-xs text-slate-500">Taxis vérifiés par arrondissement</div>
//               </div>
//             </button>

//             <button
//               onClick={() => {
//                 generateAgeSegmentationReport()
//                 setIsOpen(false)
//               }}
//               className="flex items-center gap-3 w-full p-3 rounded-lg hover:bg-slate-50 text-slate-700 hover:text-slate-900 transition-colors text-sm font-medium mt-1"
//             >
//               <div className="p-2 bg-green-50 text-green-600 rounded-lg">
//                 <FileText size={18} />
//               </div>
//               <div className="text-left">
//                 <div className="font-semibold">Age Segmentation Report</div>
//                 <div className="text-xs text-slate-500">Répartition par tranche d'âge</div>
//               </div>
//             </button>
//           </div>

//           {/* Footer */}
//           <div className="p-3 bg-slate-50 border-t border-slate-200">
//             <div className="text-xs text-slate-500">
//               Période: {dateRange.startDate.toLocaleDateString()} - {dateRange.endDate.toLocaleDateString()}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export default ReportsDropdown

'use client'

import { useState, useRef, useEffect } from 'react'
import { Download, ChevronDown, FileText, Calendar } from 'lucide-react'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

interface ReportDropdownProps {
  className?: string;
}

interface DateRange {
  label: string;
  startDate: Date;
  endDate: Date;
}

interface ReportData {
  date: string;
  verificationRates: {
    arrondissement: string;
    registered: number;
    verified: number;
    rate: number;
  }[];
  ageSegmentation: {
    ageRange: string;
    count: number;
    percentage: number;
  }[];
}

const ReportsDropdown = ({ className }: ReportDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [dateRange, setDateRange] = useState<DateRange>({
    label: 'La semaine dernière',
    startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    endDate: new Date()
  })
  const [showDateOptions, setShowDateOptions] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
        setShowDateOptions(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  // Date range options
  const dateOptions = [
    { label: 'La semaine dernière', days: 7 },
    { label: 'Le mois dernier', days: 30 },
    { label: 'Les 3 derniers mois', days: 90 },
    { label: 'Plage personnalisée', days: 0 }
  ]

  // Sample data for reports (replace with your actual data)
  const getReportData = (): ReportData => {
    const formatDate = (date: Date) => {
      return date.toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      })
    }

    return {
      date: formatDate(new Date()),
      verificationRates: [
        { arrondissement: 'Yaoundé I', registered: 212, verified: 160, rate: 75 },
        { arrondissement: 'Yaoundé II', registered: 185, verified: 114, rate: 61 },
        { arrondissement: 'Yaoundé III', registered: 200, verified: 106, rate: 53 },
        { arrondissement: 'Yaoundé IV', registered: 178, verified: 144, rate: 81 },
        { arrondissement: 'Yaoundé V', registered: 164, verified: 90, rate: 55 },
        { arrondissement: 'Yaoundé VI', registered: 181, verified: 98, rate: 54 },
        { arrondissement: 'Yaoundé VII', registered: 128, verified: 48, rate: 38 }
      ],
      ageSegmentation: [
        { ageRange: '0 – 5 ans', count: 4, percentage: 0.3 },
        { ageRange: '6 – 10 ans', count: 42, percentage: 3.4 },
        { ageRange: '11 – 15 ans', count: 317, percentage: 25.4 },
        { ageRange: 'Plus de 15 ans', count: 887, percentage: 70.9 },
        { ageRange: 'Total', count: 1250, percentage: 100 }
      ]
    }
  }

  const handleDateRangeSelect = (option: typeof dateOptions[0]) => {
    if (option.label === 'Plage personnalisée') {
      // For custom range, you could open a date picker here
      // For now, we'll use last month
      const endDate = new Date()
      const startDate = new Date()
      startDate.setDate(startDate.getDate() - 30)
      
      setDateRange({
        label: 'Plage personnalisée (30 derniers jours)',
        startDate,
        endDate
      })
    } else {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setDate(startDate.getDate() - option.days)
      
      setDateRange({
        label: option.label,
        startDate,
        endDate
      })
    }
    setShowDateOptions(false)
  }

  const generateVerificationReport = () => {
    const doc = new jsPDF()
    const data = getReportData()
    const pageWidth = doc.internal.pageSize.getWidth()
    
    // Title split into two lines
    doc.setFontSize(16)
    doc.setFont('helvetica', 'bold')
    
    // First line of title
    const titleLine1 = 'RAPPORT D\'ANALYSE DES TAUX DE TAXIS'
    const titleLine2 = 'VÉRIFIÉS PAR ARRONDISSEMENT'
    
    doc.text(titleLine1, pageWidth / 2, 20, { align: 'center' })
    doc.text(titleLine2, pageWidth / 2, 28, { align: 'center' })
    
    // Subtitle
    doc.setFontSize(12)
    doc.setFont('helvetica', 'normal')
    const subtitle = 'Plateforme digitale d\'enregistrement et de vérification des taxis'
    doc.text(subtitle, pageWidth / 2, 40, { align: 'center' })
    
    // Date
    doc.text(`Date d'édition : ${data.date}`, pageWidth / 2, 48, { align: 'center' })
    
    // Table title
    doc.setFontSize(14)
    doc.setFont('helvetica', 'bold')
    doc.text('Tableau comparatif par arrondissement', 20, 68)
    
    // Table
    autoTable(doc, {
      startY: 78,
      head: [['Arrondissement', 'Taxis enregistrés', 'Taxis vérifiés', 'Taux (%)']],
      body: data.verificationRates.map(row => [
        row.arrondissement,
        row.registered.toString(),
        row.verified.toString(),
        `${row.rate} %`
      ]),
      theme: 'grid',
      headStyles: {
        fillColor: [66, 135, 245], // Primary color
        textColor: 255,
        fontStyle: 'bold'
      },
      styles: {
        fontSize: 10,
        cellPadding: 5
      },
      margin: { left: 20, right: 20 }
    })
    
    // Footer
    const finalY = (doc as any).lastAutoTable.finalY || 100
    doc.setFontSize(10)
    doc.setFont('helvetica', 'normal')
    doc.text(`Période : ${dateRange.label}`, 20, finalY + 20)
    doc.text(`Généré le : ${new Date().toLocaleDateString('fr-FR')}`, pageWidth - 20, finalY + 20, { align: 'right' })
    
    // Save PDF
    doc.save(`rapport-verification-${dateRange.label.toLowerCase().replace(' ', '-')}-${new Date().toISOString().split('T')[0]}.pdf`)
  }

  const generateAgeSegmentationReport = () => {
    const doc = new jsPDF()
    const data = getReportData()
    const pageWidth = doc.internal.pageSize.getWidth()
    
    // Title split into two lines
    doc.setFontSize(16)
    doc.setFont('helvetica', 'bold')
    
    // First line of title
    const titleLine1 = 'RAPPORT DE SEGMENTATION DU PARC DE TAXIS'
    const titleLine2 = 'PAR TRANCHES D\'ÂGE'
    
    doc.text(titleLine1, pageWidth / 2, 20, { align: 'center' })
    doc.text(titleLine2, pageWidth / 2, 28, { align: 'center' })
    
    // Subtitle
    doc.setFontSize(12)
    doc.setFont('helvetica', 'normal')
    doc.text('Plateforme digitale d\'enregistrement et de vérification des taxis', pageWidth / 2, 40, { align: 'center' })
    
    // Date
    doc.text(`Date d'édition : ${data.date}`, pageWidth / 2, 48, { align: 'center' })
    
    // Table title
    doc.setFontSize(14)
    doc.setFont('helvetica', 'bold')
    doc.text('Tableau comparatif par tranche d\'âge du véhicule', 20, 68)
    
    // Table
    autoTable(doc, {
      startY: 78,
      head: [['Tranche d\'âge du véhicule', 'Nombre de taxis', 'Part du parc (%)']],
      body: data.ageSegmentation.map(row => [
        row.ageRange,
        row.count.toLocaleString('fr-FR'),
        `${row.percentage.toFixed(1).replace('.', ',')} %`
      ]),
      theme: 'grid',
      headStyles: {
        fillColor: [66, 135, 245], // Primary color
        textColor: 255,
        fontStyle: 'bold'
      },
      styles: {
        fontSize: 10,
        cellPadding: 5
      },
      margin: { left: 20, right: 20 }
    })
    
    // Footer
    const finalY = (doc as any).lastAutoTable.finalY || 100
    doc.setFontSize(10)
    doc.setFont('helvetica', 'normal')
    doc.text(`Période : ${dateRange.label}`, 20, finalY + 20)
    doc.text(`Généré le : ${new Date().toLocaleDateString('fr-FR')}`, pageWidth - 20, finalY + 20, { align: 'right' })
    
    // Save PDF
    doc.save(`rapport-segmentation-âge-${dateRange.label.toLowerCase().replace(' ', '-')}-${new Date().toISOString().split('T')[0]}.pdf`)
  }

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors text-sm font-semibold"
      >
        <Download size={18} />
        <span>Télécharger les rapports</span>
        <ChevronDown size={16} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-64 bg-white rounded-xl shadow-lg border border-slate-200 z-50 overflow-hidden">
          {/* Date Range Selector */}
          <div className="p-4 border-b border-slate-200">
            <button
              onClick={() => setShowDateOptions(!showDateOptions)}
              className="flex items-center justify-between w-full p-3 bg-slate-50 hover:bg-slate-100 rounded-lg text-sm font-medium text-slate-700 transition-colors"
            >
              <div className="flex items-center gap-2">
                <Calendar size={16} className="text-slate-400" />
                <span>{dateRange.label}</span>
              </div>
              <ChevronDown size={16} className={`transition-transform ${showDateOptions ? 'rotate-180' : ''}`} />
            </button>

            {showDateOptions && (
              <div className="mt-2 bg-white border border-slate-200 rounded-lg shadow-sm">
                {dateOptions.map((option) => (
                  <button
                    key={option.label}
                    onClick={() => handleDateRangeSelect(option)}
                    className="w-full px-4 py-2 text-left text-sm text-slate-700 hover:bg-slate-50 first:rounded-t-lg last:rounded-b-lg transition-colors"
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Report Options */}
          <div className="p-2">
            <button
              onClick={() => {
                generateVerificationReport()
                setIsOpen(false)
              }}
              className="flex items-center gap-3 w-full p-3 rounded-lg hover:bg-slate-50 text-slate-700 hover:text-slate-900 transition-colors text-sm font-medium"
            >
              <div className="p-2 bg-blue-50 text-primary rounded-lg">
                <FileText size={18} />
              </div>
              <div className="text-left">
                <div className="font-semibold">Rapport des taux de vérification</div>
                <div className="text-xs text-slate-500">Taxis vérifiés par arrondissement</div>
              </div>
            </button>

            <button
              onClick={() => {
                generateAgeSegmentationReport()
                setIsOpen(false)
              }}
              className="flex items-center gap-3 w-full p-3 rounded-lg hover:bg-slate-50 text-slate-700 hover:text-slate-900 transition-colors text-sm font-medium mt-1"
            >
              <div className="p-2 bg-green-50 text-green-600 rounded-lg">
                <FileText size={18} />
              </div>
              <div className="text-left">
                <div className="font-semibold">Rapport de segmentation par âge</div>
                <div className="text-xs text-slate-500">Répartition par tranche d'âge</div>
              </div>
            </button>
          </div>

          {/* Footer */}
          <div className="p-3 bg-slate-50 border-t border-slate-200">
            <div className="text-xs text-slate-500">
              Période: {dateRange.startDate.toLocaleDateString('fr-FR')} - {dateRange.endDate.toLocaleDateString('fr-FR')}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ReportsDropdown